import { render, staticRenderFns } from "./Reflexology.vue?vue&type=template&id=025f258a&scoped=true&"
import script from "./Reflexology.vue?vue&type=script&lang=js&"
export * from "./Reflexology.vue?vue&type=script&lang=js&"
import style0 from "./Reflexology.vue?vue&type=style&index=0&id=025f258a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f258a",
  null
  
)

export default component.exports